module.exports = __webpack_public_path__ + "static/media/AVK01557.4fd409ba.jpg";